import * as React from 'react';
import Button from '~/common/elements/mobile/Button';
import {buttonColor, buttonSize, buttonStyle} from '~/common/elements/mobile/consts';
import {currency, timeStamp} from '~/lib/formatters';
import {
  getPaymentName,
  getSaleStatusName,
  isRemoteCheckout,
  SaleStatus
} from '~/apps/pos/shared/services/helpers';
import {connect} from 'react-redux';
import {printSaleById} from '~/apps/pos/shared/services/print';
import Loader from '~/common/components/Loader';
import {getSaleById} from "~/apps/pos/shared/actions/sales";
import {ReceiptType} from "~/apps/pos/consts";
import {Features} from "~/apps/shared/consts";
import {getCompanyFieldLabel, getSaleNumber} from "~/apps/pos/helpers";
import {checkoutSendEmail, checkoutSendText} from "~/apps/pos/apis/message";
import SendToForm from "~/apps/pos/admin/components/sales/SendToForm";


type Props = {
  dispatch: any,
  saleId: string,
  onReturn: any,
  locations: any,
  sales: any,
  loading: boolean,
  appUrl: string,
  currentUser: any,
  organizations: any,
  features: any,
  information: any,
}

type State = {
  sendStatus: boolean | null;
  isSending: boolean;
  showEmailForm: boolean;
}


class SaleDetailView extends React.Component<Props, State> {
  private refreshSaleInterval: NodeJS.Timeout;

  constructor(props) {
    super(props);

    this.state = {
      sendStatus: null,
      isSending: false,
      showEmailForm: false,
    }
  }


  componentDidMount(): void {
    const {dispatch, saleId} = this.props;
    dispatch(getSaleById(saleId)).then(() => {
      const sale = this.props.sales[saleId];

      if (sale && sale.status === SaleStatus.PAYMENT_PROCESSING.key) {
        this.refreshSaleInterval = setInterval(() => {
          dispatch(getSaleById(saleId));
        }, 30000)
      }
    });
  }

  componentWillUnmount() {
    if (this.refreshSaleInterval) clearInterval(this.refreshSaleInterval);
  }

  handleActions = (actionKey) => {
    const {sales, saleId, features} = this.props;
    const sale = sales[saleId];
    switch (actionKey) {
      case 'receipt-print':
        // TODO: Show error message if no receipt
        if (sale) {
          const useUsualPrinters = features.includes(Features.USE_USUAL_PRINTERS);
          printSaleById(saleId, useUsualPrinters);
          // if (sale.receiptUrl) {
          //   printPdf(sale.receiptUrl);
          // }
        }
        break;
      case 'receipt-url':
        if (sale && sale.receiptUrl) {
          window.open(sale.receiptUrl);
        }
        break;
      default:
        console.warn(`>>> Not action key: ${actionKey} !!!`)
    }
  };

  getCheckoutLink = (sale, appUrl) => {
    if (!appUrl || !sale || !sale.paymentId
      || (sale.status !== SaleStatus.PAYMENT_PROCESSING.key && sale.status !== SaleStatus.PAYMENT_FAILED.key)
      || !isRemoteCheckout(sale.paymentType)) {
      return null
    }
    const absoluteLink = `${appUrl}/checkout/${sale.paymentId}/`;
    return (<a className='m__body__lbl__info' style={{wordWrap: 'break-word'}} href={absoluteLink}
               target="_blank">{absoluteLink}</a>);
  };

  handleSendText = () => {
    const {sales, saleId} = this.props;
    const sale = sales[saleId];

    this.setState({
      sendStatus: null,
      isSending: true,
    })

    checkoutSendText(sale.id)
      .then(() => {
        this.setState({
          sendStatus: true,
          isSending: false,
        })
      })
      .catch(() => {
        this.setState({
          sendStatus: false,
          isSending: false,
        })
      })
  };

  handleSendEmail = (data) => {
    const {email} = data;
    const {sales, saleId} = this.props;
    const sale = sales[saleId];

    this.setState({
      sendStatus: null,
      isSending: true,
    });


    checkoutSendEmail(sale.id, email)
      .then(() => {
        this.setState({
          sendStatus: true,
          isSending: false,
          showEmailForm: false,
        })
      })
      .catch(() => {
        this.setState({
          sendStatus: false,
          isSending: false,
        })
      })
  };

  openEmailForm = () => {
    this.setState({
      showEmailForm: true
    });
  }

  closeEmailForm = () => {
    this.setState({
      showEmailForm: false
    });
  }

  renderSuccessMessage = () => (
    <div
      className="m__body__titl--lg"
      style={{
        color: "white",
        textTransform: "uppercase",
        fontSize: "2rem",
        fontWeight: "bold",
      }}
    >
      The message has been sent
    </div>
  );

  renderFailedMessage = () => (
    <div
      className="m__body__titl--lg"
      style={{
        color: "red",
        textTransform: "uppercase",
        fontSize: "2rem",
      }}
    >
      We were unable to send a message, please try again later
    </div>
  );


  render() {
    const { sales, saleId, locations, loading, appUrl, currentUser, organizations, features, onReturn } = this.props;
    const {sendStatus, isSending} = this.state;
    const sale = sales[saleId];
    const isAdditionalFields = sale && sale.additionalFields && typeof sale.additionalFields === 'object';
    const isReceipt = sale && sale.status === SaleStatus.COMPLETED.key && sale.receiptUrl;
    const checkoutLink = this.getCheckoutLink(sale, appUrl);
    const currentOrg = organizations.entities[currentUser.organizationId];
    const hasDepartmentsFeature = features.includes(Features.DEPARTMENTS);
    const hasShowCompanyFeature = features.includes(Features.SHOW_COMPANY_FROM_SALE);
    const hasHidePoNumberFeature = features.includes(Features.PO_NUMBER_NOT_REQUIRED);
    const canSendEmails = features.includes(Features.ENABLE_SEND_CHECKOUT_EMAIL);

    if (loading) {
      return (
        <Loader className="load--full"/>
      );
    }

    if (!sale) return null;

    return (
      <div className="">
        <div className="m__body app--md__box">
          <div className="col__cont">
            <div className="col__row">
              <div className="col col--half">
                <div className="m__body__info__block">
                  <div className="m__body__lbl">Price</div>
                  <div className="m__body__lbl__info">${currency(sale.price)}</div>
                </div>
                <div className="m__body__info__block">
                  <div className="m__body__lbl">Status</div>
                  <div className="m__body__lbl__info">{getSaleStatusName(sale.status)}</div>
                </div>
                {!hasHidePoNumberFeature && (
                  <div className="m__body__info__block">
                    <div className="m__body__lbl">PO #</div>
                    <div className="m__body__lbl__info">{sale.poNumber}</div>
                  </div>
                )}
                <div className="m__body__info__block">
                  <div className="m__body__lbl">Location</div>
                  <div className="m__body__lbl__info">
                    {locations.entities[sale.locationId] && locations.entities[sale.locationId].name}
                  </div>
                </div>
              </div>
              <div className="col col--half">
                <div className="m__body__info__block">
                  <div className="m__body__lbl">#</div>
                  <div className="m__body__lbl__info">{getSaleNumber(sale, features)}</div>
                </div>
                <div className="m__body__info__block">
                  <div className="m__body__lbl">Payment Type</div>
                  <div className="m__body__lbl__info">{getPaymentName(sale.paymentType)}</div>
                </div>
                {sale.driverPhone && (
                  <div className="m__body__info__block">
                    <div className="m__body__lbl">Driver Phone</div>
                    <div className="m__body__lbl__info">{sale.driverPhone}</div>
                  </div>
                )}
                {features && features.includes(Features.ADD_COMPLETED_AT) && !!sale.completedAt && (
                  <div className="m__body__info__block">
                    <div className="m__body__lbl">Completed At</div>
                    <div className="m__body__lbl__info">{timeStamp(sale.completedAt)}</div>
                  </div>
                )}
              </div>
            </div>

            <div className="col col--full">
              {hasShowCompanyFeature && (
                <div className="m__body__info__block">
                  <div className="m__body__lbl">{getCompanyFieldLabel(features)}</div>
                  <div className="m__body__lbl__info">{sale.company}</div>
                </div>
              )}
              {hasDepartmentsFeature && (
                <div className="m__body__info__block">
                  <div className="m__body__lbl">Department</div>
                  <div className="m__body__lbl__info">{sale.department && sale.department.name}</div>
                </div>
              )}
              {sale.shift && (
                <div className="m__body__info__block">
                  <div className="m__body__lbl">Shift</div>
                  <div className="m__body__lbl__info">{sale.shift}</div>
                </div>
              )}
              <div className="m__body__info__block">
                <div className="m__body__lbl">Notes</div>
                <div className="m__body__lbl__info">{sale.description}</div>
              </div>

              {isAdditionalFields &&
                Object.keys(sale.additionalFields).map((i) => (
                  <div key={i} className="m__body__info__block">
                    <div className="m__body__lbl">{i}</div>
                    <div className="m__body__lbl__info">{sale.additionalFields[i]}</div>
                  </div>
                ))}
              {checkoutLink && (
                <div className="m__body__info__block">
                  <div className="m__body__lbl">Public link</div>
                  {checkoutLink}
                </div>
              )}
            </div>

            {features && features.includes(Features.ARRIVAL_TIME_CHECK_IN_TIME) && (
              <>
                <br />
                <div className="col__row">
                  <div className="col col--half">
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">Arrival Time</div>
                      <div className="m__body__lbl__info">{timeStamp(sale.arrivalTime)}</div>
                    </div>
                    <div className="m__body__info__block">
                      <div className="m__body__lbl">Check-in Time</div>
                      <div className="m__body__lbl__info">{timeStamp(sale.checkInTime)}</div>
                    </div>
                  </div>
                  <div className="col col--half">
                    {sale.notificationTime && (
                      <div className="m__body__info__block">
                        <div className="m__body__lbl">Notification Time</div>
                        <div className="m__body__lbl__info">{timeStamp(sale.notificationTime)}</div>
                      </div>
                    )}
                    {sale.checkoutTime && (
                      <div className="m__body__info__block">
                        <div className="m__body__lbl">Checkout Time</div>
                        <div className="m__body__lbl__info">{timeStamp(sale.checkoutTime)}</div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {isRemoteCheckout(sale.paymentType) && sale.status === SaleStatus.PAYMENT_PROCESSING.key && (
          <>
            {sendStatus === true && this.renderSuccessMessage()}
            {sendStatus === false && this.renderFailedMessage()}

            {canSendEmails && this.state.showEmailForm && (
              <SendToForm defaultValues={{ email: "" }} onSubmit={this.handleSendEmail} onBack={this.closeEmailForm} />
            )}

            {!this.state.showEmailForm && (
              <div className="confirmation__send">
                <h3 className="confirmation__send__heading">Resend the checkout link to the driver:</h3>
                <div className="confirmation__send__buttons">
                  <Button
                    title="TEXT"
                    disabled={isSending}
                    onClick={this.handleSendText}
                    buttonStyle={buttonStyle.PRIM}
                    buttonSize={buttonSize.LG}
                    buttonColor={buttonColor.WHITE}
                  />
                  {canSendEmails && (
                    <Button
                      title="Email"
                      disabled={isSending}
                      onClick={this.openEmailForm}
                      buttonStyle={buttonStyle.PRIM}
                      buttonSize={buttonSize.LG}
                      buttonColor={buttonColor.WHITE}
                    />
                  )}
                </div>
              </div>
            )}
          </>
        )}

        {isReceipt && (
          <div className="m__foot__btns" style={{ marginBottom: "24px" }}>
            {currentOrg.receiptType !== ReceiptType.ADAMS_FREIGHT_HANDLING ? (
              <div className="m__foot__btns__dbl">
                <Button
                  title="Receipt"
                  actionKey="receipt-url"
                  buttonStyle={buttonStyle.OUTL_LITE}
                  buttonSize={buttonSize.XLG}
                  onClick={(actionKey) => {
                    this.handleActions(actionKey);
                  }}
                />
                <Button
                  title="Print"
                  actionKey="receipt-print"
                  buttonStyle={buttonStyle.OUTL_LITE}
                  buttonSize={buttonSize.XLG}
                  onClick={(actionKey) => {
                    this.handleActions(actionKey);
                  }}
                />
              </div>
            ) : (
              <Button
                title="Receipt"
                actionKey="receipt-url"
                buttonStyle={buttonStyle.OUTL_LITE}
                buttonSize={buttonSize.XLG}
                onClick={(actionKey) => {
                  this.handleActions(actionKey);
                }}
              />
            )}
          </div>
        )}
        <Button title={"Close"} buttonStyle={buttonStyle.PRIM} buttonSize={buttonSize.LG} onClick={onReturn} customStyle={{width: "100%"}} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    sales: state.pos.sales.entities,
    loading: state.pos.sales.entities.loading,
    locations: state.shared.locations,
    appUrl: state.shared.information.entities.appUrl,
    currentUser: state.shared.auth.currentUser,
    organizations: state.shared.organizations,
    features: state.shared.information.entities.features,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleDetailView);
